<div class="c-modal c-modal--sm" data-testid="profile-edit-dialog" [attr.data-processing]="!!vm.processing">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="profileEditCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()" *ngIf="vm.isSignupCompleted && vm.user?.phone">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content" [ngClass]="{ 'u-no-pt': vm.isSignupCompleted }">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="o-grid o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<item-thumbnail></item-thumbnail>
					</div>
				</div>
				<p class="c-text u-ost-xl" *ngIf="!vm.isSignupCompleted">{{ 'Modal.Content.Complete_Profile_Advice' | translate }}</p>
				<form name="vm.form" #mainForm="ngForm" class="c-form u-ost-xl">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || fname.dirty) && fname.invalid }">
								<label for="{{ 'fname-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Modal.Form.Label.First_Name' | translate }}</label>
								<input id="{{ 'fname-' + vm.uid }}" name="fname" #fname="ngModel" type="text" class="c-form__input c-form__input--sm" [(ngModel)]="vm.profile.firstname" maxlength="255" pattern="^[\u0041-\u005A\u0061-\u007A\u00C0-\u00FF\u002D šŠžŽ']{0,}$" required>
								<item-form-error *ngIf="(vm.submitted || fname.dirty) && fname.invalid" [fieldName]="'Modal.Form.Label.First_Name' | translate" [error]="fname.errors"></item-form-error>
							</div>
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || lname.dirty) && lname.invalid }">
								<label for="{{ 'lname-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Modal.Form.Label.Last_Name' | translate }}</label>
								<input id="{{ 'lname-' + vm.uid }}" name="lname" #lname="ngModel" type="text" class="c-form__input c-form__input--sm" [(ngModel)]="vm.profile.lastname" maxlength="255" pattern="^[\u0041-\u005A\u0061-\u007A\u00C0-\u00FF\u002D šŠžŽ']{0,}$" required>
								<item-form-error *ngIf="(vm.submitted || lname.dirty) && lname.invalid" [fieldName]="'Modal.Form.Label.Last_Name' | translate" [error]="lname.errors"></item-form-error>
							</div>
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || email.dirty) && email.invalid }">
								<label for="{{ 'email-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Modal.Form.Label.Email' | translate }}</label>
								<input id="{{ 'email-' + vm.uid }}" name="email" #email="ngModel" type="email" class="c-form__input c-form__input--sm" [(ngModel)]="vm.profile.email" (change)="vm.handleEmailUpdate()" maxlength="255" pattern='^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' required>
								<item-form-error *ngIf="(vm.submitted || email.dirty) && email.invalid" [fieldName]="'Modal.Form.Label.Email' | translate" [error]="email.errors"></item-form-error>
								<item-form-error *ngIf="(vm.submitted || email.dirty) && !vm.isEmailFree" [fieldName]="'Modal.Form.Label.Email' | translate" [error]="{'emailFree':true}"></item-form-error>
								<p id="emailDomainErrorLabel" class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.submitted && !vm.isDomainValid">{{ vm.emailDomainError }}</p>
							</div>
							<div *ngIf="!vm.isBusinessUser" class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || phone.dirty) && (phone.invalid || !vm.countryCode) }">
								<div class="o-grid o-grid--wrap" [hidden]="vm.isVerificationProcess">
									<div class="o-grid__cell o-grid__cell--w-50 u-no-pl">
										<label for="{{ 'countryCode-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">
											{{ 'Modal.Form.Label.Country_Code' | translate }}
										</label>
										<input-autocomplete id="{{'countryCode-' + vm.uid}}"
															name="countryCode"
															[(model)]="vm.countryCode"
															[searchFn]="vm.handleCountryCodeSearch"
															[selectFn]="vm.handleCountryCodeSelect"
															[clearFn]="vm.clearCountryCodeSearch"
															[isRequired]="true"
															[minLength]="2"
															[disabled]="vm.is2faEnabled"
															[isSmall]="true">
										</input-autocomplete>
									</div>
									<div class="o-grid__cell o-grid__cell--w-50 u-no-p">
										<label for="{{ 'phone-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Modal.Form.Label.Phone' | translate }}</label>
										<input id="{{ 'phone-' + vm.uid }}" [disabled]="vm.is2faEnabled" name="phone" #phone="ngModel" type="tel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.profile.phone" maxlength="24" pattern="^[0-9 +)(-]+$" required>
									    <p class="c-text c-text--sm c-text--bold u-ost-xs" *ngIf="vm.countryCode?.dialCode && vm.profile.phone && vm.profile.phone?.length > 1">{{ 'Modal.Form.Label.Phone' | translate }}: {{vm.countryCode?.dialCode}} {{vm.profile.phone}}</p>
									</div>
								</div>
								<div class="o-grid o-grid--wrap">
									<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
										<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.submitted && !vm.countryCode">{{ 'Modal.Form.Label.Country_Code_Error_Required' | translate }}</p>
										<item-form-error *ngIf="(vm.submitted || phone.dirty) && phone.invalid" [fieldName]="'Modal.Form.Label.Phone' | translate" [error]="phone.errors"></item-form-error>
									</div>
								</div>
							</div>
							<div class="c-form__group u-osb-lg">
								<label for="{{ 'lang-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Modal.Form.Label.Device_Language' | translate }}</label>
								<mat-select id="{{ 'lang-' + vm.uid }}" name="lang" [(value)]="vm.profile.deviceLanguage" class="mat-select mat-select--sm mat-select--border" *ngIf="vm.deviceLanguages">
									<mat-option *ngFor="let language of vm.deviceLanguages ; let $index=index" [value]="language.locale">{{ language.nativeName }}</mat-option>
								</mat-select>
							</div>
						</div>
					</div>
					<div class="u-ost-md u-osb-lg" *ngIf="!vm.isSignupCompleted && vm.isRegularUser">
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': (vm.submitted || consent1.dirty) && consent1.invalid }">
							<label class="c-checkbox">
								<input type="checkbox" data-testid="profile-consent-terms" [(ngModel)]="vm.consent" name="consent" #consent1="ngModel" id="consent" required>
								<span id="consentLabel" [innerHTML]="vm.tosConsent"></span>
							</label>
						</div>
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': (vm.submitted || consent2.dirty) && consent2.invalid }">
							<label class="c-checkbox">
								<input type="checkbox" data-testid="profile-consent-privacy" [(ngModel)]="vm.consent2" name="consent2" #consent2="ngModel" id="consent2" required>
								<span id="consent2Label" [innerHTML]="vm.ppConsent"></span>
							</label>
						</div>
					</div>
					<div *ngIf="vm.isSignupCompleted && vm.hasPassword">
						<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || password.dirty) && password.invalid }">
							<label for="{{ 'password-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Modal.Form.Label.Password' | translate }}</label>
							<input id="{{ 'password-' + vm.uid }}" name="password" #password="ngModel" type="password" class="c-form__input c-form__input--sm" [(ngModel)]="vm.password.currentPassword" [required]="vm.password.newPassword || vm.password.newPasswordConfirm">
							<item-form-error *ngIf="(vm.submitted || password.dirty) && password.invalid" [fieldName]="'Modal.Form.Label.Password' | translate" [error]="password.errors"></item-form-error>
						</div>
						<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || newPassword.dirty || newPassword.touched) && newPassword.invalid }">
							<label for="{{ 'newPassword-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Modal.Form.Label.New_Password' | translate }}</label>
							<input id="{{ 'newPassword-' + vm.uid }}" name="newPassword" #newPassword="ngModel" type="password" class="c-form__input c-form__input--sm" [(ngModel)]="vm.password.newPassword" [required]="vm.password.currentPassword || vm.password.newPasswordConfirm" (input)="vm.updatePassConfErrors()" minlength="8" pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$">
							<item-form-error *ngIf="(vm.submitted || newPassword.dirty || newPassword.touched) && newPassword.invalid" [fieldName]="'Modal.Form.Label.New_Password' | translate" [error]="newPassword.errors"></item-form-error>
						</div>
						<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || newPasswordConfirm.dirty || newPasswordConfirm.touched) && newPasswordConfirm.invalid }">
							<label for="{{ 'newPasswordConfirm-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Modal.Form.Label.Password_Confirmation' | translate }}</label>
							<input id="{{ 'newPasswordConfirm-' + vm.uid }}" name="newPasswordConfirm" #newPasswordConfirm="ngModel" type="password" class="c-form__input c-form__input--sm" [(ngModel)]="vm.password.newPasswordConfirm" [required]="vm.password.currentPassword || vm.password.newPassword" (input)="vm.updatePassConfErrors()" minlength="8" pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$">
							<item-form-error *ngIf="(vm.submitted || newPasswordConfirm.dirty || newPasswordConfirm.touched) && newPasswordConfirm.invalid" [fieldName]="'Modal.Form.Label.Password_Confirmation' | translate" [error]="newPasswordConfirm.errors"></item-form-error>
							<item-form-error *ngIf="(vm.submitted || newPasswordConfirm.dirty || newPasswordConfirm.touched) && vm.passwordMismatch" [fieldName]="'Modal.Form.Label.Password_Confirmation' | translate" [error]="{'passwordVerify':true}"></item-form-error>
						</div>
						<p class="c-text c-text--s6 c-text--center u-osb-lg">{{ "Reset_Password.Password_Requirements" | translate }}</p>
					</div>
					<div class="c-panel u-no-p" style="margin-bottom: 14px">
						<button id="saveProfileButton" type="button" class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap"
								(click)="vm.submit(mainForm)"
								*ngIf="!vm.isEmployeeJoinRequestAllowed()"
								[disabled]="vm.processing || !vm.initialized || (vm.submitted && mainForm.invalid)">
							{{ 'Modal.Button.Save' | translate }}
						</button>
					</div>
	                <div *ngIf="vm.isSignupCompleted && !vm.isBusinessUser">
	                    <div style="margin-bottom:10px;" class="c-form__group" *ngIf="vm.user?.parentBusinessUser">
	                        <label class="c-form__label c-form__label--light">{{ 'Modal.Profile.Employer.Label' | translate }}</label>
	                        <p id="employerName" class="c-text">{{ vm.user?.parentBusinessUser.businessName }}</p>
	                    </div>
	                </div>
					<div [hidden]="!vm.isSignupCompleted || vm.isBusinessUser || vm.isMinudocUser" style="padding-top: 14px">
						<div id="authenticationPanelContainer" class="c-panel u-no-p u-ost-sm u-osb-sm" panel [isOpen]="vm.isAuthenticationPanelOpen">
							<div class="c-panel__header c-panel__header--sm">
								<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{ 'Modal.Profile.Authentication.Security_Settings' | translate }}</a>
							</div>
							<div class="c-panel__content u-no-ph">
								<div class="c-content u-no-ph">
									<label class="c-checkbox">
										<input (change)="vm.enableTotpAuthButtonVisible = true" type="checkbox" name="totpAuthenticationCheckbox" [(ngModel)]="vm.enableTotpAuth">
										<span id="totpAuthenticationLabel" style="margin-top: 12px;">{{ 'Modal.Profile.Authentication.Enable_2fa_Auth' | translate }}</span>
									</label>
									<p class="c-text c-text--sm u-ost-sm" *ngIf="vm.isTotpEnabledInfo" [hidden]="vm.isTotpDisabledInfo">{{ 'Modal.Profile.Authentication.Enable_2Fa_Auth_Info' | translate }}</p>
									<p class="c-text c-text--sm u-ost-sm" *ngIf="vm.isTotpDisabledInfo">{{ 'Modal.Profile.Authentication.Disable_2Fa_Auth_Info' | translate }}</p>
									<button *ngIf="vm.enableTotpAuthButtonVisible" style="margin-top: 14px"
											id="submitEnablingTotpAuthentication"
											(click)="vm.enableTotpAuthentication()"
											type="button"
											class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
										OK
									</button>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="vm.isSignupCompleted && !vm.isBusinessUser">
						<div *ngIf="vm.isChatNotificationEnabledGlobally">
							<div id="notificationPanelContainer" class="c-panel u-no-p u-ost-sm u-osb-sm" panel [isOpen]="vm.isChatNotificationPanelOpen">
								<div class="c-panel__header c-panel__header--sm">
									<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{ 'Modal.Form.Label.Notification_Settings' | translate }}</a>
								</div>
								<div class="c-panel__content u-no-ph">
									<div class="c-content u-no-ph">
										<label class="c-checkbox">
											<input (change)="vm.enableChatNotificationButtonVisible = true" type="checkbox" name="notificationCheckbox" [(ngModel)]="vm.enableChatNotification">
											<span id="notificationLabel">{{ 'Modal.Form.Label.Notify_About_Unread_Messages' | translate }}</span>
										</label>
										<p class="c-text c-text--sm u-ost-sm" *ngIf="vm.isChatNotificationEnabledInfo">{{ 'Modal.Form.Label.Enable_Chat_Notification_Info' | translate }}</p>
										<p class="c-text c-text--sm u-ost-sm" *ngIf="vm.isChatNotificationDisabledInfo">{{ 'Modal.Form.Label.Disable_Chat_Notification_Info' | translate }}</p>
										<button *ngIf="vm.enableChatNotificationButtonVisible" style="margin-top: 14px"
														id="submitEnablingNotificationViaEmail"
														(click)="vm.enableNotificationViaEmail()"
														type="button"
														class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
											OK
										</button>
									</div>
								</div>
							</div>
						</div>
						<div id="employerPanelContainer" class="c-panel u-no-p u-ost-sm u-osb-sm" panel [isOpen]="vm.isEmployerPanelOpen" *ngIf="!vm.previsitLocation && !vm.user?.parentBusinessUser">
							<div class="c-panel__header c-panel__header--sm">
								<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{ 'Modal.Profile.Employer.Add' | translate }}</a>
							</div>
							<div class="c-panel__content u-no-ph" [ngClass]="{'u-of-visible': vm.isEmployerPanelOverflowVisible}">
								<div class="c-content u-no-ph">
									<p class="c-text u-osb-lg">{{ 'Modal.Profile.Employer.Info' | translate }}</p>
									<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.employerSubmitInvalid && (!vm.employer || (!vm.isIntegrationValid && !vm.isEmployeeJoinRequestAllowed())), 'u-osb-lg': vm.employer?.configId, 'u-no-mb': !vm.employer?.configId}">
										<label for="{{'employer-' + vm.uid}}" class="c-form__label c-form__label--light">{{ 'Modal.Profile.Employer.Input_Label' | translate }}</label>
										<input-autocomplete id="{{'employer-' + vm.uid}}" 
											name="employer" 
											[(model)]="vm.employer" 
											[searchFn]="vm.handleEmployerSearch" 
											[clearFn]="vm.clearEmployerSearch" 
											[isRequired]="false" 
											[minLength]="2" 
											[isSmall]="true">
										</input-autocomplete>
										<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.employerSubmitInvalid && !vm.employer">{{ 'Modal.Profile.Employer.Error_Required' | translate }}</p>
										<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.employer && !vm.isIntegrationValid && !vm.isEmployeeJoinRequestAllowed()">
											{{ 'Modal.Profile.Employer.Error_No_Integration' | translate }}
										</p>
										<p class="c-text c-text--sm u-ost-sm" *ngIf="vm.employer && vm.isEmployeeJoinRequestAllowed()">
											{{ 'Modal.Profile.Employer.JoinRequest' | translate }}
										</p>
									</div>
									<div class="c-form__group u-no-m" [ngClass]="{'c-form__group--error': (vm.employerSubmitInvalid || employerSearchConsent.dirty) && employerSearchConsent.invalid }" *ngIf="vm.employer?.configId">
										<label class="c-checkbox">
											<input type="checkbox" name="employerSearchConsent" #employerSearchConsent="ngModel" [(ngModel)]="vm.employerSearchConsent" required>
											<span id="employerSearchConsentLabel">{{ 'Modal.Profile.Employer.Consent' | translate }}</span>
										</label>
										<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="(vm.employerSubmitInvalid || employerSearchConsent.dirty) && employerSearchConsent.invalid">{{ 'Modal.Profile.Employer.Error_Search_Consent' | translate }}</p>
									</div>
									<button style="margin-top: 14px"
	                                        id="sendEmployerJoinRequestButton"
											(click)="vm.sendEmployerJoinRequest(mainForm)"
											[disabled]="vm.sendingEmployerJoinRequest"
											type="button"
											*ngIf="vm.isEmployeeJoinRequestAllowed()"
											class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
										{{ 'Modal.Profile.Employer.Send' | translate }}
									</button>
									<button style="margin-top: 14px"
	                                        id="checkEmployerStatusButton"
											(click)="vm.checkEmployerStatus(mainForm)"
											[disabled]="vm.processingEmployerStatusCheck"
											type="button"
											*ngIf="vm.employer && vm.employerSearchConsent"
											class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
										{{ 'Modal.Profile.Employer.Send' | translate }}
									</button>
								</div>
							</div>
						</div>
						<div id="elisaDiscountPanelContainer" class="c-panel u-no-p u-ost-sm u-osb-sm" panel [isOpen]="vm.isElisaDiscountPanelOpen" *ngIf="!vm.previsitLocation && vm.user?.origin == 'minudoc.ee' && !vm.user?.businessUserType && vm.elisaPackageList?.length > 0">
							<div class="c-panel__header c-panel__header--sm">
								<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{ 'Modal.Profile.Employer.Activate_Elisa_Account' | translate }}</a>
							</div>
							<div class="c-panel__content u-no-ph" [ngClass]="{'u-of-visible': vm.isElisaDiscountPanelOverflowVisible}">
								<div class="c-content u-no-ph" *ngIf="!vm.isElisaActivationRequestSent && !vm.hasElisaBusinessWallet">
									<div class="c-content u-no-ph" *ngIf="vm.joinRequestRejected">
										<div class="error-message">
											<div style="text-align: center">{{ 'Modal.Profile.Employer.Activate_Elisa_Rejected' | translate }}</div>
										</div>
									</div>
									<p class="c-text u-osb-lg">{{ 'Modal.Profile.Employer.Activate_Elisa_Account_Info' | translate }}</p>
									<div style="padding-bottom: 14px">
										<mat-select id="elisaPackageSelection" name="elisaPackageSelection" [(value)]="vm.elisaPackage" class="mat-select mat-select--sm mat-select--border">
											<mat-option *ngFor="let elisaPackage of vm.elisaPackageList ; let $index=index"
													   [value]="elisaPackage">
												{{elisaPackage.name}}
											</mat-option>
										</mat-select>
									</div>
									<label class="c-checkbox">
										<input type="checkbox" name="isElisaConsentConfirmed" [(ngModel)]="vm.isElisaConsentConfirmed">
										<span id="isElisaConsentConfirmedLabel">{{ 'Modal.Profile.Employer.Activate_Elisa_Account_Consent' | translate }} <a href="{{vm.webPPLink}}" target="_blank">{{ 'Modal.Profile.Employer.Here' | translate }}</a></span>
									</label>
									<button id="handleElisaActivationRequestButton" style="margin-top: 14px" (click)="vm.handleElisaActivationRequest()" type="button" [disabled]="!vm.isElisaConsentConfirmed || vm.processingMobilePackageCheck" class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
										{{ 'Modal.Profile.Employer.ButtonActivate' | translate }}
									</button>
								</div>
								<div class="c-content u-no-ph" *ngIf="vm.isElisaActivationRequestSent">
									<div class="info-message">
										<div style="text-align: center"><img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon_send_email.svg" class="c-image c-image--sm" /></div>
										<div style="text-align: center">{{ 'Modal.Profile.Employer.ActivationRequestDeliveryStatus' | translate }}</div>
									</div>
								</div>
								<div class="c-content u-no-ph" *ngIf="vm.hasElisaBusinessWallet">
									<div class="info-message">{{ 'Modal.Profile.Employer.ElisaPackageAlreadyActivated' | translate }}</div>
								</div>
							</div>
						</div>
						<div id="deleteMyAccountPanelContainer" class="c-panel u-no-p u-ost-sm u-osb-sm" panel [isOpen]="vm.isDeleteMyAccountPanelOpen" *ngIf="!vm.user?.businessUserType">
	                        <div class="c-panel__header c-panel__header--sm">
	                            <a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{ 'Modal.Content.Delete_My_Account' | translate }}</a>
	                        </div>
	                        <div class="c-panel__content u-no-ph">
	                            <div class="c-content u-no-ph">
	                                <p class="c-text u-osb-lg">{{ 'Modal.Content.Delete_My_Account_Disclaimer' | translate }}</p>
	                                <button id="deleteMyAccountButton" style="margin-top: 14px" (click)="vm.handleDeleteMyAccount()" type="button" class="c-button c-button--s1 c-button--narrow c-button--fit u-no-wrap">
	                                    {{ 'Modal.Content.Delete_My_Account_Button' | translate }}
	                                </button>
	                            </div>
	                        </div>
	                    </div>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
